'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

// For some weird reason, in Chrome, `setTimeout()` would lag up to a second (or more) behind.
// Turns out, Chrome developers have deprecated `setTimeout()` API entirely without asking anyone.
// Replacing `setTimeout()` with `requestAnimationFrame()` can work around that Chrome bug.
// https://github.com/bvaughn/react-virtualized/issues/722


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCreateRef = require('react-create-ref');

var _reactCreateRef2 = _interopRequireDefault(_reactCreateRef);

var _requestAnimationFrameTimeout = require('request-animation-frame-timeout');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react2.default.PureComponent || _react2.default.Component;

// Sits at the bottom of a page and displays notifications
var Snackbar = (_temp2 = _class = function (_PureComponent) {
	_inherits(Snackbar, _PureComponent);

	function Snackbar() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Snackbar);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.snackbar = (0, _reactCreateRef2.default)(), _this.status = 'idle', _this.queue = [], _this.next = function () {
			// Get the next notification from the queue
			// (will be `undefined` if the queue is empty)
			var value = _this.queue.shift();

			// Reset the notification display
			_this.setState({
				value: value,
				queueSize: _this.queue.length,
				height: undefined,
				// wide: undefined,
				hiding: false
			});

			if (value) {
				_this.status = 'active';
				// `state.show` will be set to `true` later,
				// when the height of the element is measured
				// (which is after it renders)
			} else {
				// If the queue is empty, then just exit
				_this.status = 'idle';
			}
		}, _this.hide = function () {
			var hideAnimationDuration = _this.props.hideAnimationDuration;

			// Start the hiding animation for the notification

			_this.setState({ show: false, hiding: true });

			// Display the next notification
			// after the currently being hidden one
			// finishes its hiding animation.
			_this.show_next_snack_timeout = (0, _requestAnimationFrameTimeout.setTimeout)(_this.next, hideAnimationDuration);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Snackbar, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			(0, _requestAnimationFrameTimeout.clearTimeout)(this.auto_hide_timer);
			(0, _requestAnimationFrameTimeout.clearTimeout)(this.show_next_snack_timeout);
			(0, _requestAnimationFrameTimeout.clearTimeout)(this.show_snack_timeout);
		}
	}, {
		key: 'receiveNewValue',
		value: function receiveNewValue(prevProps) {
			var value = this.props.value;

			// If `value` has changed then push it to the queue.

			if (value && value !== prevProps.value) {
				// Add the notification to the queue
				this.push(value);
			}
		}

		// Adds a notification to the queue

	}, {
		key: 'push',
		value: function push(newValue) {
			// Add the notification to the queue
			this.queue.push(newValue);
			this.setState({
				queueSize: this.queue.length
			});
			// If the notification queue was empty
			// then kick-start it.
			if (this.status === 'idle') {
				this.next();
			}
		}

		// Displays the next notification in the queue

	}, {
		key: 'scheduleAutoHide',
		value: function scheduleAutoHide() {
			var _props = this.props,
			    minTime = _props.minTime,
			    lengthTimeFactor = _props.lengthTimeFactor;
			var value = this.state.value;

			if (value.duration === -1) {
				return;
			}
			// The total display duration (in milliseconds) of a snack
			// is `minTime + message.length * lengthTimeFactor`
			var length = typeof value.content === 'string' ? value.content.length : value.length || 0;
			var duration = value.duration || minTime + length * lengthTimeFactor;
			// Hide the notification after it expires.
			if (window.rruiCollapseOnFocusOut !== false) {
				this.auto_hide_timer = (0, _requestAnimationFrameTimeout.setTimeout)(this.hide, duration);
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this2 = this;

			var _state = this.state,
			    height = _state.height,
			    value = _state.value;
			var show = this.state.show;

			// If `value` got updated then push it to the list of `queue`.

			this.receiveNewValue(prevProps);

			// The notification DOM element has just been rendered
			// which means its dimensions are set by now.
			// Calculate the notification container DOM element height
			// so that the slide-from-bottom animation knows
			// its target Y-position for the CSS `translate` transform.
			if (value) {
				if (height === undefined) {
					height = this.snackbar.current.offsetHeight;
					// const wide = this.snackbar.current.offsetWidth === document.documentElement.clientWidth
					var marginBottom = parseInt(getComputedStyle(this.snackbar.current).marginBottom);
					this.setState({
						height: height,
						// wide,
						marginBottom: marginBottom
					});
				} else if (prevState.height === undefined) {
					// An "anti-lag" timeout added in order to set `show: true`
					// after the web browser has re-rendered.
					// Otherwise it would jump to fully shown in Chrome when
					// there's a queue of snacks waiting to be shown
					var anti_lag_timeout = 100;
					// Handle the changed state (due to the `.setState()` call above).
					this.show_snack_timeout = (0, _requestAnimationFrameTimeout.setTimeout)(function () {
						// Sometimes (for example, when the browser tab was in background)
						// this timer hasn't fired until the timeout
						_this2.setState({ show: true });
					}, anti_lag_timeout);
				} else if (!prevState.show && show) {
					this.scheduleAutoHide();
				}
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var type = this.props.type;
			var _state2 = this.state,
			    show = _state2.show,
			    value = _state2.value,
			    height = _state2.height,
			    marginBottom = _state2.marginBottom,
			    hiding = _state2.hiding,
			    queueSize = _state2.queueSize;


			var style = {};

			if (!show) {
				// If no snack is being shown,
				// or if a snack is about to be shown,
				// then shift it under the screen's bottom border
				// to show the slide-from-bottom animation at the next step.
				if (height !== undefined) {
					style.transform = 'translateY(' + (height + marginBottom) + 'px)';
				}
				if (!hiding) {
					style.transition = 'none';
				}
			}

			var showCloseButton = value && (value.close || typeof value.content === 'string' && value.duration === -1);

			return _react2.default.createElement(
				'div',
				{
					ref: this.snackbar,
					style: style,
					className: (0, _classnames2.default)('rrui__snackbar', value && value.type && 'rrui__snackbar--' + value.type, {
						'rrui__snackbar--hidden': !show
					}) },
				value && !value.component && _react2.default.createElement(
					'p',
					{ className: 'rrui__snackbar__text' },
					value.content
				),
				value && value.component && _react2.default.createElement(value.component, _extends({}, value.props, {
					hide: this.hide
				})),
				(value && value.action || showCloseButton) && _react2.default.createElement(
					'div',
					{ className: 'rrui__snackbar__actions' },
					value && value.action && _react2.default.createElement(
						'button',
						{
							type: 'button',
							onClick: value.action.onClick,
							'class': 'rrui__snackbar__action rrui__button-reset' },
						value.action.title
					),
					showCloseButton && _react2.default.createElement(
						'button',
						{
							type: 'button',
							onClick: this.hide,
							className: 'rrui__snackbar__close rrui__button-reset' },
						_react2.default.createElement(Close, null)
					)
				),
				queueSize > 0 && _react2.default.createElement(
					'div',
					{ className: 'rrui__snackbar__count' },
					queueSize + 1
				)
			);
		}
	}]);

	return Snackbar;
}(PureComponent), _class.propTypes = {
	// Snackbar value (either a message, or an object)
	value: _propTypes2.default.shape({
		// Notification content.
		content: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),

		// Instead of `content` property one may supply `component` property
		// which must be a React component which receives all "rest" `value` properties
		// and also `hide`property (a function that hides the notification).
		component: _propTypes2.default.func,

		// `props` are passed to `component`.
		props: _propTypes2.default.object,

		// If `content` is a `string` then its `length` is calculated automatically.
		// Otherwise one may pass `length` manually.
		// It's used for calculating notification `duration`.
		length: _propTypes2.default.number,

		// `type` is appended as a BEM modifier to `.rrui__snackbar` CSS class.
		// E.g. `.rrui__snackbar--error` for `{ type: "error" }`.
		type: _propTypes2.default.string,

		// How long does the notification stay.
		// Pass `-1` for it to stay until it's closed manually.
		duration: _propTypes2.default.number,

		// (optional)
		// Action button on the right side.
		action: _propTypes2.default.shape({
			onClick: _propTypes2.default.func.isRequired,
			title: _propTypes2.default.string.isRequired
		}),

		// (optional)
		// Set to `true` to show a close button.
		// Close button is automatically shown
		// when `content` is text and `duration` is `-1`.
		close: _propTypes2.default.bool
	}),

	// // "Snack" showing CSS animation duration.
	// // Is 225 milliseconds by default.
	// showAnimationDuration : PropTypes.number.isRequired,

	// "Snack" hiding CSS animation duration.
	// Is 195 milliseconds by default.
	hideAnimationDuration: _propTypes2.default.number.isRequired,

	// The total display duration (in milliseconds) of a snack
	// is `minTime + message.length * lengthTimeFactor`
	minTime: _propTypes2.default.number.isRequired,
	lengthTimeFactor: _propTypes2.default.number.isRequired
}, _class.defaultProps = {
	// showAnimationDuration : 225,
	hideAnimationDuration: 195,
	minTime: 1200,
	lengthTimeFactor: 60
}, _temp2);
exports.default = Snackbar;


function Close() {
	return _react2.default.createElement(
		'svg',
		{ className: 'rrui__snackbar__close-icon', viewBox: '0 0 100 100' },
		_react2.default.createElement('line', { stroke: 'currentColor', strokeWidth: '10', x1: '2', y1: '2', x2: '98', y2: '98' }),
		_react2.default.createElement('line', { stroke: 'currentColor', strokeWidth: '10', x1: '2', y1: '98', x2: '98', y2: '2' })
	);
}
//# sourceMappingURL=Snackbar.js.map